export default __webpack_public_path__ + "static/media/young-woman.23817948.jpg";